import { BENEFICIAIRE_CLES, CLE_REPARTITION_REVENUS, CORRESPONDANCE_TAUX_IP, ITT_UNITS, SMIGS_AFRIQUE_OUEST } from "../../../variables/constants";
import { baremeCapitalisation } from "../../../pages/sinistres/components/utils/useHooks";

export const getAge = (birthdate) => {
    const today = new Date();
    const birth = new Date(birthdate);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age;
};

export const getAgeFromSinistre = (birthdate, sinistreDate) => {
    const today = new Date(sinistreDate);
    const birth = new Date(birthdate);
    return today.getFullYear() - birth.getFullYear();
};

export const getAgeCategory = (age) => {
    if (age < 15) return "Moins_de_15_ans";
    if (age >= 15 && age <= 19) return "De_15_a_19_ans";
    if (age >= 20 && age <= 24) return "De_20_a_24_ans";
    if (age >= 25 && age <= 29) return "De_25_a_29_ans";
    if (age >= 30 && age <= 39) return "De_30_a_39_ans";
    if (age >= 40 && age <= 59) return "De_40_a_59_ans";
    if (age >= 60 && age <= 69) return "De_60_a_69_ans";
    if (age >= 70) return "Soixante_dix_ans_et_plus";
    return null;
};

export const getValeurPointIP = (tauxIP, age) => {
    if (typeof tauxIP !== 'number' || typeof age !== 'number') return null;
    const ageCategory = getAgeCategory(age);
    if (!ageCategory) return null;
    const tauxIPRow = CORRESPONDANCE_TAUX_IP.find(
        row => tauxIP >= row.tauxIP.min && tauxIP <= row.tauxIP.max
    );
    if (!tauxIPRow) return null;
    return tauxIPRow.age[ageCategory];
};

export const getPrixRente = async (age, sexe, baremeCapitalisationToChoose) => {
    if (typeof age !== 'number' || age < 0 || age > 100) return null;
    if (sexe !== 'MASCULIN' && sexe !== 'FEMININ') return null;
    const genre = sexe === 'MASCULIN' ? 'M' : 'F';
    const bareme = await baremeCapitalisation(baremeCapitalisationToChoose, age, genre);
    const rente = bareme.data;
    return rente ? rente.prixUnFrancRente : null;
};

export const getSmigByCountryAndYear = (countryName, year) => {
    const countryData = SMIGS_AFRIQUE_OUEST[countryName];
    if (!countryData) return null;
    const sortedData = [...countryData].sort((a, b) => b.anneeDebut - a.anneeDebut);
    const smigEntry = sortedData.find(entry => year >= entry.anneeDebut);
    return smigEntry ? smigEntry.smig : null;
};

export const getPourcentageRepartition = (situation, ayantDroit) => {
    if (!situation || !ayantDroit) return null;
    const situationRow = CLE_REPARTITION_REVENUS.find(row => row.situation === situation);
    if (!situationRow) return null;
    const pourcentage = situationRow[ayantDroit];
    if (pourcentage === undefined) return null;
    return pourcentage;
};

export const getPrejudiceMoralBeneficiaireKey = (ayantDroit) => {
    if (!ayantDroit || typeof ayantDroit !== 'string') return 0;
    const key = BENEFICIAIRE_CLES[ayantDroit.toUpperCase()];
    return key !== undefined ? key : 0;
};

export const getIttUnitLabel = (unit = 'JOURS') => {
    const option = ITT_UNITS.find(item => item.value === unit);
    return option?.label || 'Jours';
};

export const convertIttValueToDays = (value, unit = 'JOURS') => {
    const numericValue = parseFloat(value);
    if (Number.isNaN(numericValue)) return 0;
    switch (unit) {
        case 'SEMAINES': return numericValue * 7;
        case 'MOIS': return numericValue * 30;
        default: return numericValue;
    }
};

export const convertDaysToIttValue = (days, unit = 'JOURS') => {
    const numericValue = parseFloat(days);
    if (Number.isNaN(numericValue)) return 0;
    switch (unit) {
        case 'SEMAINES': return numericValue / 7;
        case 'MOIS': return numericValue / 30;
        default: return numericValue;
    }
};

const trimTrailingZeros = (value) => {
    const numericString = `${value}`;
    if (!numericString.includes('.')) return numericString;
    return numericString.replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
};

export const formatIttValueForDisplay = (days, unit = 'JOURS') => {
    const value = convertDaysToIttValue(days, unit);
    if (!Number.isFinite(value)) return '0';
    const rounded = Math.round(value * 100) / 100;
    return trimTrailingZeros(rounded === 0 ? 0 : rounded);
};
